import HandleResponses from '@common/utils/handleResponses';
import axios from '../../../axios';

const actions = {
  async trackingList({ commit }, { id }) {
    try {
      const result = await axios.get(`/order/${id}/transporter_bookings_tracking_list`);
      commit('SET_INDENT_TRACKING', result.data || []);
      return result.data || [];
    } catch (error) {
      commit('SET_INDENT_TRACKING', []);
      return HandleResponses.Status(error);
    }
  },
  async driverValidation(_, data) {
    try {
      const result = await axios.post('/order/assign_truck/validate', data);
      return result;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },
  async getVerification(_, data) {
    try {
      const result = await axios.get(`/order/${data.orderNo}/assign_truck/validate_status?transaction_id=${data.transactionId}`);
      return result.data;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },

  async addAttachment(_, data) {
    try {
      const result = await axios.post('/attachment', data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async removeAttachments(_, data) {
    try {
      const result = await axios.delete(`/attachment/${data.attachment_id}`);
      return result;
    } catch (error) {
      console.log('Error removing attachment:', error);
      return HandleResponses.Status(error);
    }
  },

  async addExcessMaterials({ commit }, params) {
    try {
      commit('SET_EXCESS_MATERIAL_LOADING', true);
      const result = await axios.post('/material_excess', { data: params });
      if (result.data) {
        commit('SET_EXCESS_MATERIALS', result.data);
      }
      return result.data;
    } catch (error) {
      return error;
    } finally {
      commit('SET_EXCESS_MATERIAL_LOADING', false);
    }
  },

  async getExcessMaterials({ commit, state }, payload) {
    let orderId;

    if (payload && typeof payload === 'object') {
      ({ orderId } = payload);
    } else {
      orderId = payload;
    }
    try {
      commit('SET_EXCESS_MATERIAL_LOADING', true);
      const result = await axios.get('/material_excess', {
        params: { orderNo: orderId },
      });
      if (result.data) {
        commit('SET_EXCESS_MATERIALS', result.data);
      }
      return result.data;
    } catch (error) {
      return error;
    } finally {
      commit('SET_EXCESS_MATERIAL_LOADING', false);
    }
  },

  async deleteExcessMaterial({ commit }, id) {
    try {
      commit('SET_EXCESS_MATERIAL_LOADING', true);
      const result = await axios.delete(`/material_excess/${id}`);
      return result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    } finally {
      commit('SET_EXCESS_MATERIAL_LOADING', false);
    }
  },

  async bulkDeleteExcessMaterials({ commit }, materialIds) {
    try {
      commit('SET_EXCESS_MATERIAL_LOADING', true);
      const result = await axios.delete('/material_excess/bulk_delete', { data: { ids: materialIds } });
      return result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    } finally {
      commit('SET_EXCESS_MATERIAL_LOADING', false);
    }
  },

  async getSdlcCategorization(_, params) {
    try {
      const result = await axios.get('/sdlc_categorization', { params });
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async createSdlcCategorization(_, { data }) {
    try {
      const result = await axios.post('/sdlc_categorization', { data });
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
};

export default actions;
